import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MainService } from '../services/delavci/main.service';

import{ User } from '../models/User';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
import { LoginPartnerService } from '../services/partner/login-partner/login-partner.service';
import { Constants } from '../utils/constants';
import { AppConfigServiceService } from '../services/app-config-service.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public user: User;
  public loginForm: UntypedFormGroup;
  public errorAtLogin: string;
  public alertClose = false;
  public submitted = false;
  public assets;
  public showValidation;
  public navigateUrl;
  public email;
  public password;
  public onSubmit = false;
  constructor(private mainService: MainService, private loginPartnerService: LoginPartnerService,
              private router: Router, private _snackbar: MatSnackBar, public MY_CONSTANTS: Constants,
              private appConfigService: AppConfigServiceService, private route: ActivatedRoute) {

    if (this.mainService.currentUserValue) {
      this.router.navigate(['/']);
    }
    if (this.loginPartnerService.currentPartnerValue) {
      this.router.navigate(['/pregled-helpdeska']);
    }
  }

  ngOnInit() {
    console.log("version ziga_v2");
    this.mainService.changeHref(this.router.url);
    this.assets = this.appConfigService.apiAssets;
    this.showValidation = this.appConfigService.configShowValidation;
    if(this.showValidation) {
      this.loginForm = new UntypedFormGroup({
        email: new UntypedFormControl('', [
          Validators.required,
        ]),
        password: new UntypedFormControl('', [Validators.required, Validators.minLength(8)])
      });
    } else {
      this.loginForm = new UntypedFormGroup({
        email: new UntypedFormControl('', [
          Validators.required,
        ]),
        password: new UntypedFormControl('', Validators.required)
      });
    }
    this.navigateUrl = this.route.snapshot.queryParams['returnUrl'];
  }


  onLoginSubmit() {
    this.submitted = true;
    this.onSubmit = true;
    if (this.loginForm.invalid) {
      this.submitted = false;
      return;
  }
    if (!this.loginPartnerService.currentPartnerValue) {
      this.mainService.loginUser(this.loginForm.value.email, this.loginForm.value.password).subscribe(data => {
        this.user = data.data;
        if (this.user) {
          this.mainService.setCurrentUser(this.user, this.loginForm.value.email);
          if(this.navigateUrl) {
            this.router.navigate([this.navigateUrl]);
          } else {
            this.router.navigate(['/']);
          }
        }
        this.submitted = false;
      }, error => {
        this.errorAtLogin = error.error.errorUser;
        this.submitted = false;
        this._snackbar.open(this.errorAtLogin, '', {
          duration: 2000,
        });
      }, () => {
      });
    }
  }

  onPartner() {
    if(this.navigateUrl) {
      this.router.navigate(['/login-partner'], { queryParams: { returnUrl: this.navigateUrl}});
    } else {
      this.router.navigate(['/login-partner']);
    }
  }
}
